import script from "./PrintTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintTable.vue?vue&type=script&lang=ts&setup=true"

import "./PrintTable.vue?vue&type=style&index=0&id=309eba4d&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309eba4d"]])

export default __exports__